import { modelOptions, post, prop, PropType } from "@typegoose/typegoose";
import { z } from "zod";
import { getZodSchemaFromClass, validate } from "../../../zod-decorator/index.js";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../../schemaBase.js";
import {
    SupplementalZoneGraphInfoFieldsWithDefaults,
    SupplementalZoneGraphInfoSchemaTypes,
} from "../../types/supplementalZoneGraphInfo.d.js";
import { DtoValidatorTypes } from "../../validatableClass.js";
import { SupplementalZoneDataStream } from "./supplementalZoneDataStream.js";

const SCHEMA_KEY = "SupplementalZoneGraphInfo" as const;

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<SupplementalZoneGraphInfo>>(...addSchemaKeyHook(SCHEMA_KEY))
export class SupplementalZoneGraphInfo extends SchemaBase<
    SupplementalZoneGraphInfo,
    SupplementalZoneGraphInfoFieldsWithDefaults
> {
    static readonly schemaKey = SCHEMA_KEY;

    @validate({ schemaKey: SCHEMA_KEY })
    readonly schemaKey = SCHEMA_KEY;

    @validate({
        childClass: SupplementalZoneDataStream,
        childClassTransform: (object) => z.array(object).optional(),
    })
    @prop({ type: () => SupplementalZoneDataStream, required: true, default: [] }, PropType.ARRAY)
    supplementalDataStreams: SupplementalZoneDataStream[] = [];

    static dtoValidators: DtoValidatorTypes<SupplementalZoneGraphInfoSchemaTypes>;

    constructor(
        properties?: SchemaConstructorArgs<SupplementalZoneGraphInfo, SupplementalZoneGraphInfoFieldsWithDefaults>,
    ) {
        super(properties);
        Object.assign(this, properties);
    }
}

SupplementalZoneGraphInfo.dtoValidators = getZodSchemaFromClass(
    SupplementalZoneGraphInfo,
) as unknown as DtoValidatorTypes<SupplementalZoneGraphInfoSchemaTypes>;
